
import { FloatingFeature } from "@models";

export class LanguageFeature extends FloatingFeature {
  type: "Standard" | "Common" | "Exotic" | "Specific" = "Standard"; // Standard means Common or Exotic, just not Specific only.
  count = 1;
  language_ids: string[] = []; // if it's specific, then these are the ids that it can be

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      let language_id = "";
      this.type = obj.type ? obj.type : "Standard";
      language_id = obj.language_id ? obj.language_id : "";
      
      if (obj.language_ids) {
        this.language_ids = obj.language_ids;
      } else if (language_id !== "") {
        this.language_ids = [language_id];
      }
      this.count = obj.count ? obj.count : 1;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     let language_id = "";
      
  //     this.type = obj.type ? obj.type : "Standard";
  //     language_id = obj.language_id ? obj.language_id : "";
      
  //     if (obj.language_ids) {
  //       this.language_ids = obj.language_ids;
  //     } else if (language_id !== "") {
  //       this.language_ids = [language_id];
  //     }
  //     this.count = obj.count ? obj.count : 1;
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      type: this.type,
      count: this.count,
      language_ids: this.language_ids
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof LanguageFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: LanguageFeature) {
    this.type = copyMe.type;
    this.count = copyMe.count;
    this.language_ids = [...copyMe.language_ids];
  }

  clone(drop_ids = false): LanguageFeature {
    const new_obj = new LanguageFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}